export default __webpack_public_path__ + "static/media/award_mvp_1.bef8febe.png";